var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ik-data-table',{ref:"brandingReportSetting",attrs:{"model":_vm.model,"entity-name":"报告设置"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }